import styled from '@emotion/styled'
import { ITheme } from 'utils/type'

export const AccordionShowButton = styled('button')`
  label: AccordionShowButton;
  background: none;
  border: none;
  color: ${(props) => props.theme.colors.primary};
  > span {
    color: transparent;
    pointer-events: none;
    position: absolute;
  }
`
